import React from 'react'

import Box from 'components/Box'
import Button from 'components/Buttons/Button'
import Modal from 'components/Modal'
import Text from 'components/Text'

import { LeadInfo } from 'store/types'
import { LeadList } from './LeadList'

type LeadListModalProps = {
  accessor?: string
  isVisible?: boolean
  onClose: () => void
  onSubmit: (lead?: LeadInfo) => void
}

export const LeadListModal = ({ accessor, isVisible = true, onClose, onSubmit }: LeadListModalProps) => {
  const [selectedLead, setSelectedLead] = React.useState<LeadInfo | undefined>(undefined)

  const handleSubmit = () => {
    setSelectedLead(undefined)
    onSubmit(selectedLead)
    onClose()
  }

  const handleSelectRow = (lead?: LeadInfo) => {
    setSelectedLead(lead)
  }

  return (
    <Modal
      visible={isVisible}
      header={
        <Text fontSize={16} fontWeight="medium">
          lead_list
        </Text>
      }
      footer={
        <Box display="flex" justifyContent="space-between" width="100%">
          <Button mr="40px" variant="ghost" onClick={onClose}>
            cancel_btn
          </Button>
          <Button disabled={!selectedLead} variant="fill" onClick={handleSubmit}>
            select
          </Button>
        </Box>
      }
      customSize={{ maxWidth: '1200px', maxHeight: '1055px' }}
      onClose={onClose}
    >
      <LeadList accessor={accessor} onSelectRow={handleSelectRow} selectedLead={selectedLead} />
    </Modal>
  )
}

export default LeadListModal
